import { useMemo } from 'react';
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import useWindowSize from '../../../../../../helper/hooks/useWindowSize';
import VideoSection from './graph/video';
import { useDispatch, useSelector } from 'react-redux';
import { updateOnBoardingSettings } from '../../../../../../store/actions/creator/creatorOnBoarding';

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 10,
    zIndex: 13,
    marginBottom: -10
    }
}));

function StaticVideoSection() {
  const classes = useStyles();

  const { module4Settings, userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { youtube, module4Data } = userPreferences;
  const { analyze, session } = module4Data.value;
  const { session_type } = session;
  const stimulus = analyze.stimulus;
  const { graphZoom, analyseEnd, analyseStart } = module4Settings;
  const { width } = useWindowSize();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const {thumbnail, url} = JSON.parse(youtube.value);
  const play_url = session?.stimulus[0]?.play_url;

  const graphLength = useMemo(() => {
    if (stimulus && session_type === 'ASYNC') return stimulus.stimulus_video_length;
    return analyseEnd - analyseStart
  }, [stimulus, analyseEnd, analyseStart]);

  return (
    <div className={classes.root} style={{marginBottom: isMobile ? 40: -10}}>
      <VideoSection
        width={width - 30}
        height={(width - 30) * 135 / 240}
        video={play_url || url}
        videoStart={0}
        videoEnd={stimulus ? stimulus.stimulus_video_length : graphLength}
        img={thumbnail}
        popOut={(e: any) => dispatch(updateOnBoardingSettings('xScroll', e * 15 / Math.pow(graphZoom, 2)))}
        sessionType={'ASYNC'}
        graphLength={graphLength}
        onVideoPlay={()=>{}}
      />
    </div>
  )
}

export default StaticVideoSection;